import './spinner.scss'

const Spinner = () => {
    return (
        <div class="loader-container">
            <div class="loader"></div>
        </div>
    )
}

export default Spinner